// frontend/src/tabs/restrictToHorizontalAxis.js
//
// The TabStrip's dnd-kit modifier.
//
// The strip is a one-dimensional list, so a drag has no meaning off the
// horizontal axis. Zeroing the vertical translate is not cosmetic: dnd-kit
// applies modifiers BEFORE collision detection — the collision rect is the
// dragging node's rect adjusted by the *modified* translate
// (@dnd-kit/core `getAdjustedRect(draggingNodeRect, modifiedTranslate)`)
// and the same translate drives the visual transform. Unconstrained, a drag
// below the strip's bottom border would carry the collision rect out of the
// tab row, where each tab's intersection score falls off with vertical
// distance until it hits zero and drops out entirely (rectIntersection keeps
// only ratio > 0), and the drag would shake.
export const restrictToHorizontalAxis = ({ transform }) => ({ ...transform, y: 0 });
